export default "/packs/images/ablty-logo~71ccb9b95616124fc9d7e162c6dbd508.svg";